import PropTypes from 'prop-types';
import React from 'react';

import Fare from '../../records/Fare';
import Ticket from '../../records/Ticket';
import OrderFare from '../../records/order/Fare';
import OrderTicket from '../../records/order/Ticket';
import { toPounds } from '../../helpers/Currency';
import { queryBuilder, getUrl } from '../../helpers/NRETicketLink';
import { NREIncompatibleRailcards } from '../../constants/AppConstants';
import t from '../../lib/I18n';

import ExternalLink from '../general/ExternalLink';

function NRETicketLink ({ fare, ticket }) {
    if ((ticket.railcard && NREIncompatibleRailcards.includes(ticket.railcard.code))
        || fare.isSeason()
        || fare.isRoversRangers()
        || fare.isDaySave()) {
            return null;
    }

    const quantity = ticket.adults || ticket.children;
    const price = toPounds(ticket.price / quantity).toFixed(2);

    let passenger = t('global.adult');
    if (ticket.children > 0) {
        passenger = t('global.child');
    }

    const linkParams = Object.assign({ price, passenger }, fare.getNRELinkParams());

    let linkQuery = queryBuilder(fare, ticket);

    return (
        <div className="nre-link">
            <ExternalLink message={ t('booking.fares.nre-link.text') }
                href={ getUrl(linkParams, linkQuery) } className="text-sm" />
        </div>
    );
}

NRETicketLink.propTypes = {
    fare: PropTypes.oneOfType([
        PropTypes.instanceOf(Fare),
        PropTypes.instanceOf(OrderFare)
    ]),
    ticket: PropTypes.oneOfType([
        PropTypes.instanceOf(Ticket),
        PropTypes.instanceOf(OrderTicket)
    ])
};

export default NRETicketLink;



// WEBPACK FOOTER //
// ./src/components/fares/NRETicketLink.js